import queryString from "query-string";
import { useLocation, useHistory } from "react-router-dom";
import { ISLEntriesDetailsProps } from "../components/SLEntriesDetails";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getTileName(location: any): string {
  const querystring = queryString.parse(location.search);
  const originatingTileName = querystring.tileName as string;
  return originatingTileName || "";
}

export function getStateObjects(
  location: ReturnType<typeof useLocation>
): ReturnType<ISLEntriesDetailsProps["routeState"]> | undefined {
  if (location.state) {
    const st = location.state as any;
    return {
      origin: st.origin,
      state: st.state
    };
  }
  return undefined;
}

export function navigateToOrigin(
  history: ReturnType<typeof useHistory>,
  location: ReturnType<typeof useLocation>
): void {
  const stateObjects = getStateObjects(location);
  if (stateObjects) {
    const uri = stateObjects.origin;
    history.push(uri, stateObjects);
  } else {
    history.push("/sldashboard", undefined);
  }
}

export function redirectMeToTheOrigin(
  history: ReturnType<typeof useHistory>,
  location: ReturnType<typeof useLocation>,
  timeout = 3000
): void {
  setTimeout(() => {
    // This timeout is for UX purposes, allows the user to see the notifications before navigating away
    navigateToOrigin(history, location);
  }, timeout);
}
